import { useContext } from "react";
import { Modal } from "react-bootstrap";
import processHtml from './processHtml';
import { HotelContext } from "../context/hotel";
import { CheckInContext } from "../context/checkin";
import { getPropertyTermsAndConditionsPlaceholderText } from "./CheckIn/hotelTermsAndConditionsPlaceholder";

import { hotelRegulationsText as hr_offgrid } from "./CheckIn/HotelRegulations-offgrid";
import { hotelRegulationsText as hr_costa } from "./CheckIn/HotelRegulations-Costa";
import { hotelRegulationsText as hr_hostz_betahouse } from "./CheckIn/HotelRegulations-Hostz-betahouse";
import { hotelRegulationsText as hr_hostz_themyde } from "./CheckIn/HotelRegulations-Hostz-themyde";
import { hotelRegulationsText as hr_hostz_arosa } from "./CheckIn/HotelRegulations-Hostz-arosa";
import { hotelRegulationsText as hr_hostz_cozy } from "./CheckIn/HotelRegulations-Hostz-cozy";
import { hotelRegulationsText as hr_hostz_steiners } from "./CheckIn/HotelRegulations-Hostz-steiners";
import { hotelRegulationsText as hr_simplex } from "./CheckIn/HotelRegulations-simplex";
import { hotelRegulationsText as hr_hostz_sigma } from "./CheckIn/HotelRegulations-Hostz-sigma";

import { isCostaGalana, isOffgrid, isHostzBetaHouse, isHostzMyde, isHostzArosa, isHostzCozy, isHostzSteiners, isSimplex, isHostzSigma } from "./CheckIn/hotelConditions";

const InfoModalTermsAndConditions = ({ hotelId, hotelCode, language, show, setShow }) => {
    const { placeholders: hotelPlaceholders } = useContext(HotelContext);
    const { data: checkIn } = useContext(CheckInContext);

    let translatedText2 = "";

    const phText = getPropertyTermsAndConditionsPlaceholderText(
        language,
        hotelPlaceholders,
        checkIn?.placeholders
    );
    if (phText) {
        translatedText2 = processHtml(phText);
    } else if (isOffgrid(hotelId)) {
        translatedText2 = processHtml(hr_offgrid?.[language] || hr_offgrid?.["en-US"] || "")
    } else if (isCostaGalana(hotelId)) {
        translatedText2 = processHtml(hr_costa?.[language] || hr_costa?.["en-US"] || "")
    } else if (isHostzBetaHouse(hotelId)) {
        translatedText2 = processHtml(hr_hostz_betahouse?.[language] || hr_hostz_betahouse?.["en-US"] || "")
    } else if (isHostzMyde(hotelId)) {
        translatedText2 = processHtml(hr_hostz_themyde?.[language] || hr_hostz_themyde?.["en-US"] || "")
    } else if (isHostzArosa(hotelId)) {
        translatedText2 = processHtml(hr_hostz_arosa?.[language] || hr_hostz_arosa?.["en-US"] || "")
    } else if (isHostzCozy(hotelId)) {
        translatedText2 = processHtml(hr_hostz_cozy?.[language] || hr_hostz_cozy?.["en-US"] || "")
    } else if (isHostzSteiners(hotelId)) {
        translatedText2 = processHtml(hr_hostz_steiners?.[language] || hr_hostz_steiners?.["en-US"] || "")
    } else if (isSimplex(hotelId)) {
        translatedText2 = processHtml(hr_simplex?.[language] || hr_simplex?.["de"] || "")
    } else if (isHostzSigma(hotelId)) {
        translatedText2 = processHtml(hr_hostz_sigma?.[language] || hr_hostz_sigma?.["en-US"] || "")
    }
    return (
        <>
            <Modal
                show={show}
                onHide={() => setShow(false)}
                className={`info-modal info-modal-terms-and-conditions hotel-${hotelCode}`}
            >
                <div className="modal-content-custom">
                    <Modal.Body className="modal-body-custom my-2">
                        <div className="text-center p-4 mb-4">
                            <p style={{ whiteSpace: "break-spaces", textAlign: "left" }}>{translatedText2}</p>
                        </div>
                    </Modal.Body>
                </div>
            </Modal >
        </>
    );
};

export default InfoModalTermsAndConditions;
